import React from 'react';
import { formatErrorMessage } from '../utils';

interface ErrorMessageProps {
  content: string;
  errorType?: 'ratelimited' | 'overloaded' | 'internal' | 'interrupt';
  id: string;
  onTryAgain?: () => void;
  isLastError?: boolean;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  content,
  errorType,
  id,
  onTryAgain,
  isLastError,
  className = '',
}) => {
  const errorMessage = formatErrorMessage(content, errorType);

  return (
    <div className={`text-destructive ${className}`} data-msg-id={id}>
      <span className="whitespace-pre-wrap break-words">{errorMessage}</span>
      {isLastError && onTryAgain && (
        <span
          className="ml-2 text-xs cursor-pointer hover:underline"
          onClick={onTryAgain}
        >
          (click to retry)
        </span>
      )}
    </div>
  );
};
